import { useContext } from "react";
import { CommissioningStateContext } from "../../hooks/use_commissioning_state_changes";
import { hasPermission, isComponentDisabledForUpdates } from "../../../../../../login/login_utils";
import {
  isCompleted,
  isPendingDeviceControl,
  isPendingDeviceControlStart,
} from "../../enum/commissioning_required_action";
import { DeviceControlComponent } from "./device_control_component";
import Privilege from "../../../../../../../enums/privilege_enum";
import { useUserPrivilegeKeyPermissionsMap } from "../../../../../../../hooks/use_backend";
import CommissioningReportComponent from "./commissioning_report_component";

const FinalVerification = ({ requiredPrivilege }) => {
  const permissionMap = useUserPrivilegeKeyPermissionsMap();
  const { commissioningState, finalVerificationMutation, isFinalVerificationStepMutating } =
    useContext(CommissioningStateContext);

  const verificationIsCommissioned = isCompleted(commissioningState.finalVerificationStep.required_action);
  const isLocked = !commissioningState.validationState.all_ongoing_devices_completed || verificationIsCommissioned;
  const userNotAllowedToUpdate = isComponentDisabledForUpdates(permissionMap, requiredPrivilege.getPrivilegeKey());
  const isAdmin = hasPermission(permissionMap, Privilege.ADMIN_OVERVIEW.getPrivilegeKey(), false);
  const pendingDeviceControl = isPendingDeviceControl(commissioningState.finalVerificationStep.required_action);
  const pendingDeviceControlStart = isPendingDeviceControlStart(
    commissioningState.finalVerificationStep.required_action,
  );
  const hasMetering = commissioningState.validationState.has_network_metering;

  return (
    <div>
      {pendingDeviceControl || pendingDeviceControlStart ? (
        <DeviceControlComponent
          isAdmin={isAdmin}
          isStart={pendingDeviceControlStart}
          isUAAccepted={commissioningState.validationState.user_agreement_accepted}
          isMutating={isFinalVerificationStepMutating}
          isLocked={isLocked}
          userNotAllowedToUpdate={userNotAllowedToUpdate}
          mutation={finalVerificationMutation}
          step={commissioningState.finalVerificationStep}
        />
      ) : (
        <CommissioningReportComponent
          isMutating={isFinalVerificationStepMutating}
          requiredPrivilege={requiredPrivilege}
          isLocked={isLocked}
          isAdmin={isAdmin}
          hasMetering={hasMetering}
          mutation={finalVerificationMutation}
          step={commissioningState.finalVerificationStep}
        />
      )}
    </div>
  );
};

export default FinalVerification;
